
import { Fragment } from 'react';

import useTeamEntryManagementByIdHQOrgUnitSelection from './UseTeamEntryManagementByIdHQOrgUnitSelection';

import OmeMeetEntryInfoDropdown from '../../../components/dropdowns/OmeMeetEntryInfoDropdown';
import OrgUnitOmeMeetEntryTreeView from '../../../components/tree/orgUnitOmeMeetEntryTree/OrgUnitOmeMeetEntryTreeView';

import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Headings from '@usas/ui-web/components/headings/Headings';

import Constants from '@usas/ui-web/utils/Constants';

const TeamEntryManagementByIdHQOrgUnitSelection = () => {
    const { handleSubmit, formState, errorState, onValueTextPairChanged, onFormValueChanged, onBackClicked,
        omeMeetState, omeMeetEntryInfoState, omeMeetOrgUnitEntryState, omeMeetOrgUnitEntryInfoState, orgUnitOmeMeetEntryState
    } = useTeamEntryManagementByIdHQOrgUnitSelection();

    return (
        <Fragment>
            <div>
                <div className="row usas-extra-top-margin">
                    <div className="col-xs-12">
                        <Headings.H3>Enter Meet</Headings.H3>
                    </div>
                </div>
                <div className="row usas-extra-top-margin usas-extra-bottom-margin">
                    <div className="col-xs-12">
                        <Headings.H6>Make a Selection</Headings.H6>
                    </div>
                </div>
                <form onSubmit={handleSubmit} noValidate>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            {omeMeetEntryInfoState.options?.length === 2 ?
                                <ReadOnly
                                    label="OME Meet"
                                    name="omeMeetEntryId"
                                    value={formState.omeMeetEntryName}
                                /> :
                                <OmeMeetEntryInfoDropdown
                                    label="OME Meet*"
                                    name="omeMeetEntryId"
                                    value={formState.omeMeetEntryId}
                                    error={errorState.omeMeetEntryId}
                                    message={errorState.omeMeetEntryId}
                                    onChange={(value, newValueLabel, e) => {
                                        e && e.target && e.target.value &&
                                            onValueTextPairChanged(value, 'omeMeetEntryId', newValueLabel, 'omeMeetEntryName');
                                        onFormValueChanged('orgUnit', []);
                                    }}
                                    omeMeetId={omeMeetState.objData?.omeMeetId}
                                    isCurrent={true}
                                />}
                        </div>
                        {formState.omeMeetEntryId > 0 &&
                            <div className="col-xs-12 col-sm-6">
                                <OrgUnitOmeMeetEntryTreeView
                                    label="Team Options*"
                                    name="orgUnit"
                                    value={formState.orgUnit}
                                    error={errorState.orgUnit}
                                    message={errorState.orgUnit}
                                    selectableLeavesOnly={true}
                                    singleSelect={true}
                                    onChange={(newValue) => { onFormValueChanged('orgUnit', newValue) }}
                                    omeMeetId={omeMeetState.objData?.omeMeetId}
                                    omeMeetEntryId={formState.omeMeetEntryId}
                                />

                            </div>
                        }
                    </div>
                    <div className="row usas-extra-top-margin usas-extra-bottom-margin">
                        <div className="col-xs-12 usas-extra-top-margin">
                            <PrimaryButton type="submit">Continue</PrimaryButton>&nbsp;
                            <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>
                        </div>
                    </div>
                </form>
            </div>
            <PopUpModal
                widthPct={50}
                maxWidth={250}
                title={Constants.SAVING_MSG}
                displayPopUp={omeMeetOrgUnitEntryState.isSaving} />
            <PopUpModal
                widthPct={50}
                maxWidth={250}
                title={Constants.LOADING_MSG}
                displayPopUp={(omeMeetState.isArrayLoading && omeMeetOrgUnitEntryState.isSaving === false)
                    || omeMeetEntryInfoState.isArrayLoading || orgUnitOmeMeetEntryState.isArrayLoading || omeMeetOrgUnitEntryInfoState.isObjLoading} />
        </Fragment>
    );
};

export default TeamEntryManagementByIdHQOrgUnitSelection;